import i18n from 'i18n';
import { ModelTypeEnum } from 'modules/environments/interfaces';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: Record<string, GenericFormItem[]> = {
  generalSettings: [
    {
      gridXs: 12,
      gridMd: 4,
      label: 'ENVIRONMENT_NAME_KEY',
      stateKey: 'name',
      validateOnChange: true,
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'ENVIRONMENT_ID_KEY',
      stateKey: 'environment_uuid',
      disabled: true,
      validateOnChange: true,
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'LICENSES_KEY',
      stateKey: 'licenses.license_limit',
      validateOnChange: true,
      mask: '9'.repeat(30),
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'PROJECT_ID_SKY_KEY',
      stateKey: 'easysky_project_id',
      validateOnChange: true,
    },
    {
      gridXs: 12,
      gridMd: 12,
      label: 'COMPARTMENT_ID_KEY',
      stateKey: 'provider.compartment_id',
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'USERS_ADMIN_KEY',
      stateKey: 'trusted_users',
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'PRODUCT_KEY',
      stateKey: 'product',
      isSelect: true,
      options: [
        { value: 'autosky', label: 'Autosky' },
        { value: 'business_one', label: 'SAP' },
      ],
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'PRODUCT_TYPE_KEY',
      stateKey: 'product_type',
      isSelect: true,
      validateOnChange: true,
      options: [],
    },
  ],

  users: [
    {
      gridXs: 12,
      gridMd: 4,
      label: 'VIRTUALIZER_KEY',
      stateKey: 'user_connection.virtualizer',
      isSelect: true,
      options: [
        { value: 'connect', label: 'ConnectSky' },
        {
          value: 'rdp',
          label: `Microsoft Remote Desktop (${i18n.t('FILE_KEY')})`,
        },
        {
          value: 'rdp_direct',
          label: 'Microsoft Remote Desktop (Direct Connect)',
        },
        { value: 'rdp_app', label: 'Microsoft Remote Desktop (RemoteApp)' },
        { value: 'connect_direct', label: 'ConnectSky (Direct Connect)' },
        { value: 'tsplus', label: 'TSPlus (WebBrowser HTML5)' },
        { value: 'tsplus_remote_app', label: 'TSPlus (RemoteApp)' },
        {
          value: 'tsplus_all',
          label: 'TSPlus (WebBrowser HTML and RemoteApp)',
        },
        { value: 'aspw', label: 'ASPW (WebBrowser)' },
        { value: 'aspw_all', label: 'ASPW (WebBrowser and RemoteApp)' },
      ],
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'PRIMARY_PORT_KEY',
      stateKey: 'user_connection.service_port',
      mask: '9'.repeat(30),
      validateOnChange: true,
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'SECONDARY_PORT_KEY',
      stateKey: 'user_connection.web_port',
      mask: '9'.repeat(30),
      validateOnChange: true,
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'QUALITY_KEY',
      stateKey: 'user_connection.quality',
      isSelect: true,
      options: [
        { value: 'high', label: 'HIGH_KEY' },
        { value: 'default', label: 'DEFAULT_KEY' },
        { value: 'low', label: 'LOW_KEY' },
      ],
    },
  ],

  publications: [
    {
      gridXs: 12,
      gridMd: 4,
      label: 'IMAGE_PUBLICATION_TYPE_KEY',
      stateKey: 'publication.type',
      isSelect: true,
      options: [
        { value: ModelTypeEnum.customImage, label: 'Custom Image' },
        { value: ModelTypeEnum.bootVolume, label: 'Boot Volume' },
        {
          value: ModelTypeEnum.bootVolumeBackup,
          label: 'Boot Volume Backup',
        },
      ],
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'MAX_PUBLICATIONS_KEY',
      stateKey: 'publication.limit_instance_blocking_publications',
      validateOnChange: true,
      type: 'number',
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'MAX_DAILY_PUBLICATIONS_KEY',
      stateKey: 'publication.limit_instance_blocking_publications_daily',
      validateOnChange: true,
      type: 'number',
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'PUBLICATIONS_OLD_INSTANCES_KEY',
      stateKey: 'publication.publication_can_block_old_instances',
      isSelect: true,
      options: [
        { value: 'true', label: 'YES_KEY' },
        { value: 'false', label: 'NO_KEY' },
      ],
    },
    {
      gridXs: 12,
      label: 'BLOCK_TIME_KEY',
      stateKey: 'publication.schedule_instances_blocking.time',
      isTime: true,
    },
    {
      gridXs: 12,
      gridMd: 8,
      label: 'EMAIL_KEY_WARNING_APPLICATION',
      stateKey: 'publication.schedule_instances_blocking.warning_emails',
    },
  ],

  applications: [
    {
      gridXs: 12,
      gridMd: 4,
      label: 'REGISTER_THROUGH_KEY',
      stateKey: 'client_apps.registration_source',
      isSelect: true,
      options: [
        { value: 'autosky', label: 'Autosky' },
        { value: 'platform', label: 'PLATFORM_KEY' },
      ],
    },
    {
      gridXs: 12,
      gridMd: 4,
      label: 'REGISTER_MODE_KEY',
      stateKey: 'client_apps.registration_mode',
      isSelect: true,
      options: [
        { value: 'simple', label: 'SIMPLE_KEY' },
        { value: 'advanced', label: 'ADVANCED_KEY' },
      ],
    },
  ],
};

export default fields;
